import { BoneModal } from './BoneModal';

export function initLanguageModal()
{
	const elem = document.getElementById('gr-language-menu');
	if (!elem)
	{
		return;
	}

	const hasLangData = !!window.LANG;

	const modal = new BoneModal(elem);
	if (!modal)
	{
		return;
	}

	if (modal.elem)
	{
		modal.elem.addEventListener('click', function closeModalOnNavigation(e) {
			const isLink = e.target.tagName.toUpperCase() === 'A';
			if (isLink) {
				modal.close();
			}
		});
	}

	// click delegate to handle # links
	document.body.addEventListener('click', (e) =>
	{
		if (e.target.tagName.toUpperCase() === 'A')
		{
			const url = new URL(e.target.href);
			if (url && url.hash === '#gr-language-menu')
			{
				e.preventDefault();
				e.stopImmediatePropagation();
				modal.open();
			}
		}
	});
}


function updateLanguageDisplays(slug, langs)
{
	if (!slug)
	{
		return;
	}

	const langData = langs.find((lang) => lang.slug === slug);

	const displays = document.querySelectorAll('.lang-display');
	if (!displays || !displays.length)
	{
		return;
	}

	const shortLabel = langData ? langData.slug : slug;
	const fullLabel = langData ? langData.name : slug; // slug fallback

	displays.forEach((display) =>
	{
		const isShort = display.classList.contains('lang-display--short');
		const label = isShort ? shortLabel : fullLabel;
		display.innerHTML = label;
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/language-modal.js